import http from "./httpService";
import { HEADER_TENANT_ACT } from "../constants/constant";

class CommonApi {
  headers = {
    accept: "application/json, text/plain, */*",
    "content-type": "application/json",
  };

  async loadPortal(data) {
    const query = window.location.search;
    var path = window.location.pathname;
    path = path.length === 0 ? '/' : path;
    const custHeader ={
		...this.headers,
      "portalpath": path,
    };

    return http.post(`${process.env.REACT_APP_BASE_URL ?? ''}api/portal/load${query}`, JSON.stringify(data), {
		headers: custHeader
	});
  }

  async getPortalInfo() {
    const query = window.location.search;
    var path = window.location.pathname;
    path = path.length === 0 ? '/' : path;
    const custHeader ={
    	...this.headers,
      "portalpath": path,
    };

    return http.get(`${process.env.REACT_APP_BASE_URL ?? ''}api/portal/info${query}`, {
		headers: custHeader
	});
  }

  async getPartnerInfo() {
    const response = await http.get(process.env.REACT_APP_BASE_URL + `api/partner`);
    return response;
  }

  async getPartnerStore() {
    return http.get(process.env.REACT_APP_BASE_URL + `api/partner/store`);
  }

  async getPartnerTrackingCode() {
    return http.get(process.env.REACT_APP_BASE_URL + `api/partner/tracking/code`);
  }

  async testExistEmail(email) {
    return http.get(process.env.REACT_APP_BASE_URL + `api/customer/email/exist/${email}`);
  }

  async testExistPhoneNumber(phone) {
    return http.get(process.env.REACT_APP_BASE_URL + `api/customer/phone/exist/${phone}`);
  }

  async updateCustomer(data, extraHeaders = {}) {
    return http.post(process.env.REACT_APP_BASE_URL + `api/customer`, JSON.stringify(data), {
      headers: { ...this.headers, ...(extraHeaders || {}) },
    });
  }

  async createUpdateAddress(data, extraHeaders = {}) {
    return http.post(process.env.REACT_APP_BASE_URL + `api/customer/address`, JSON.stringify(data), {
      headers: { ...this.headers, ...(extraHeaders || {}) },
    });
  }

  async lookupCustomer(birthday, firstName, lastName, email, phone) {
    return http.get(process.env.REACT_APP_BASE_URL + `api/customer/lookup?birthday=${birthday}&firstName=${firstName}&lastName=${lastName}&email=${email}&phone=${phone}`);
  }

  async getCustomerInfo(customerId) {
    return http.get(process.env.REACT_APP_BASE_URL + `api/customer/${customerId}`);
  }

  async getBookingInfo(bookingId) {
    return http.get(process.env.REACT_APP_BASE_URL + `api/booking/${bookingId}`);
  }

   async createBooking(data, extraHeaders = {}) {
    return http.post(process.env.REACT_APP_BASE_URL + `api/booking`, JSON.stringify(data), {
      headers: { ...this.headers, ...(extraHeaders || {}) },
    });
  }

  async createBookingQuestions(bookingId, data, extraHeaders = {}) {
    return http.post(
      process.env.REACT_APP_BASE_URL + `api/booking/${bookingId}/question`,
      JSON.stringify(data),
      {
        headers: { ...this.headers, ...(extraHeaders || {}) },
      }
    );
  }

  async setBillMethodDefault(data, extraHeaders = {}) {
    return http.post(process.env.REACT_APP_BASE_URL + `api/bill/method`, JSON.stringify(data), {
      headers: { ...this.headers, ...(extraHeaders || {}) },
    });
  }

  async getLocationList(status = "ACTIVE", returnMaster = true, sortOrder = {}) {
    const sortField = sortOrder.sort?.toUpperCase() || '';
    const orderType = sortOrder.order || '';
    return http.get(process.env.REACT_APP_BASE_URL + `api/location/list?status=${status}&sort=${sortField}&sortOrder=${orderType}&returnMaster=${returnMaster}&internal=false`);
  }

  async getLocationHours(id, pickupType) {
    return await http.get(`${process.env.REACT_APP_BASE_URL ?? ''}api/location/${id}/hour?pickupType=${pickupType}`);
  }
  async getCombLocationHours(pickupType) {
    return await http.get(`${process.env.REACT_APP_BASE_URL ?? ''}api/location/hour?pickupType=${pickupType}`);
  }
  
  async getPartnerPhone() {
    return await http.get(`${process.env.REACT_APP_BASE_URL ?? ''}api/partner/phone`);
  }

    /**
   * Upload a file using multipart/form-data to the new endpoint.
   * Supports real network progress via axios onUploadProgress.
   *
   * @param {File}   file        - The raw File object from the input element
   * @param {{ type: string, extension: string, source?: string }} meta
   * @param {(percent: number) => void} [onProgress] - Called with 0-100 as bytes are sent
   * @param {string} [actAsIden] - Optional act-as tenant header
   */
    async postResourceMultipart(file, meta, onProgress, actAsIden = "") {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("type", meta.type);
      formData.append("extension", meta.extension);
      if (meta.source) formData.append("source", meta.source);
  
      const headers = {};
      if (actAsIden.length > 0) headers[HEADER_TENANT_ACT] = actAsIden;
  
      return http.post(process.env.REACT_APP_BASE_URL + `api/resource/upload`, formData, {
        headers,
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / (progressEvent.total || 1)
          );
          if (onProgress) onProgress(percentCompleted);
        },
      });
    }
  
}

export const commonApi = new CommonApi();
